import { PageRoutes as DebitPageRoutes } from 'debit-card/constants/PageRoutes'
export const useCommon = () => {
  const route = useRoute()
  const tabbarPages = [DebitPageRoutes.DebitIndex, DebitPageRoutes.CardPackage, DebitPageRoutes.MyCards]
  const isTabbarPage = computed(() => {
    return tabbarPages.includes(route.path as any)
  })
  return {
    isTabbarPage,
  }
}
